import { regionFromAdmin, type Location } from '@shh/shared';
import { locale } from './locale';

/**
 * Place search for weather and daylight (Open-Meteo geocoding: free, no key, no account).
 * Only the city name goes out – never an address (DSGVO data minimisation).
 */
export async function searchPlaces(name: string): Promise<(Location & { area?: string })[]> {
  if (name.trim().length < 2) return [];
  const url = `https://geocoding-api.open-meteo.com/v1/search?${new URLSearchParams({
    name: name.trim(),
    count: '6',
    language: locale,
    format: 'json',
  })}`;
  const res = await fetch(url);
  if (!res.ok) return [];
  const json = (await res.json()) as {
    results?: {
      name: string;
      latitude: number;
      longitude: number;
      admin1?: string;
      country_code?: string;
    }[];
  };
  return (json.results ?? []).map((r) => ({
    name: r.name,
    latitude: Math.round(r.latitude * 100) / 100, // ~1 km – plenty for weather
    longitude: Math.round(r.longitude * 100) / 100,
    // shown next to the name; the federal state picks the school holidays (1.24)
    area: [r.admin1, r.country_code].filter(Boolean).join(', '),
    region: regionFromAdmin(r.admin1, r.country_code),
  }));
}
